import { Notification, isChatNotification } from 'types/notifications'

const isOrderInNotifications = (orderNumber: string, notifications: Notification[]) => {
  const notificationsForOrder = notifications.filter((val) => {
    return isChatNotification(val) && val.orderId === orderNumber
  })

  return !!notificationsForOrder.length
}

export default isOrderInNotifications
